











































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import OrganisationService from '@/services/organisation.service';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import { Action } from 'vuex-class';
import GenericButton from '@/components/GenericButton.vue';

@Component({
  components: {
    GenericButton,
    Dialog,
    CancelButton,
    ConfirmButton,
  },
})
export default class OrganisationAdmin extends Vue {

  @Prop() private organisation: any;
  @Action private addToastErrorMessage: any;

  private showDialog: boolean = false;
  private loading: boolean = false;

  private counts: any = {};

  private async deleteOrg() {
    this.loading = true;
    try {
      this.counts = (await OrganisationService.terminateOrganisation(this.organisation.id, false));
      this.showDialog = true;
    } finally {
      this.loading = false;
    }
  }

  private async confirm() {
    this.loading = true;
    try {
      const response = await OrganisationService.terminateOrganisation(this.organisation.id, true);

      if (response.success === 'ok') {
        const oldId = this.organisation.id;
        try {
          await this.$store.dispatch('addOrganisationsAsync');
        } catch (e) {
          const err = e as Error;
          this.addToastErrorMessage(err.message);
        }
        this.showDialog = false;
        this.$emit('deleted');
        if (oldId !== this.organisation.id) {
          this.$router.push('/');
        }
      } else if (response.error) {
        throw new Error(response.error);
      } else {
        throw new Error('An unexpected error occurred terminating the organisation');
      }
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(err.message);
    } finally {
      this.loading = false;
    }
  }
}
